var map = {
	"./auth/auth.module": [
		"./src/app/auth/auth.module.ts"
	],
	"./pages/aside-left-display-disabled-loader-enabled-enabled-type-spinner-message/index/index.module": [
		"./src/app/theme/pages/aside-left-display-disabled-loader-enabled-enabled-type-spinner-message/index/index.module.ts",
		"index.module.0"
	],
	"./pages/aside-left-display-disabled-loader-enabled-enabled-type-spinner-message/non-club-athlete/index.module": [
		"./src/app/theme/pages/aside-left-display-disabled-loader-enabled-enabled-type-spinner-message/non-club-athlete/index.module.ts",
		"index.module"
	],
	"./pages/default/association/clubdetails/clubdetails.module": [
		"./src/app/theme/pages/default/association/clubdetails/clubdetails.module.ts",
		"clubdetails.module"
	],
	"./pages/default/association/clubs/clubs.module": [
		"./src/app/theme/pages/default/association/clubs/clubs.module.ts",
		"clubs.module.0"
	],
	"./pages/default/association/dashboard/dashboard.module": [
		"./src/app/theme/pages/default/association/dashboard/dashboard.module.ts",
		"dashboard.module.2"
	],
	"./pages/default/association/staff/staff.module": [
		"./src/app/theme/pages/default/association/staff/staff.module.ts",
		"staff.module"
	],
	"./pages/default/association/staffdetails/staffdetails.module": [
		"./src/app/theme/pages/default/association/staffdetails/staffdetails.module.ts",
		"staffdetails.module"
	],
	"./pages/default/athletedetails/athletedetails.module": [
		"./src/app/theme/pages/default/athletedetails/athletedetails.module.ts",
		"athletedetails.module"
	],
	"./pages/default/club/dashboard/dashboard.module": [
		"./src/app/theme/pages/default/club/dashboard/dashboard.module.ts",
		"dashboard.module.1"
	],
	"./pages/default/inner/inner.module": [
		"./src/app/theme/pages/default/inner/inner.module.ts",
		"inner.module"
	],
	"./pages/default/inner2/inner2.module": [
		"./src/app/theme/pages/default/inner2/inner2.module.ts",
		"inner2.module"
	],
	"./pages/default/not-found/not-found.module": [
		"./src/app/theme/pages/default/not-found/not-found.module.ts",
		"not-found.module"
	],
	"./pages/default/parent/athletes/athletes.module": [
		"./src/app/theme/pages/default/parent/athletes/athletes.module.ts",
		"athletes.module"
	],
	"./pages/default/parent/dashboard/dashboard.module": [
		"./src/app/theme/pages/default/parent/dashboard/dashboard.module.ts",
		"dashboard.module.0"
	],
	"./pages/default/profile/profile.module": [
		"./src/app/theme/pages/default/profile/profile.module.ts",
		"profile.module"
	],
	"./pages/default/reports/reports.module": [
		"./src/app/theme/pages/default/reports/reports.module.ts",
		"reports.module"
	],
	"./pages/default/roster/roster.module": [
		"./src/app/theme/pages/default/roster/roster.module.ts",
		"roster.module"
	],
	"./pages/default/sgadmin/clubs/clubs.module": [
		"./src/app/theme/pages/default/sgadmin/clubs/clubs.module.ts",
		"clubs.module"
	],
	"./pages/default/sgadmin/dashboard/dashboard.module": [
		"./src/app/theme/pages/default/sgadmin/dashboard/dashboard.module.ts",
		"dashboard.module"
	],
	"./pages/default/teamdetails/teamdetails.module": [
		"./src/app/theme/pages/default/teamdetails/teamdetails.module.ts",
		"teamdetails.module"
	],
	"./pages/default/teams/teams.module": [
		"./src/app/theme/pages/default/teams/teams.module.ts",
		"teams.module"
	],
	"./pages/default/workflows/workflows.module": [
		"./src/app/theme/pages/default/workflows/workflows.module.ts",
		"workflows.module"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;


//////////////////
// WEBPACK FOOTER
// ./src/$$_lazy_route_resource lazy
// module id = ./src/$$_lazy_route_resource lazy recursive
// module chunks = main